<template>
<div>
    <md-dialog md-open-from="#upload" md-close-to="#upload" ref="upload">
        <md-dialog-title>Profile Photo Upload</md-dialog-title>
        <md-dialog-content>
            <form enctype="multipart/form-data" novalidate>
                <md-input-container>
                    <label>Profile Picture</label>
                    <md-file @selected="onFileUpload($event)" accept="image/*"></md-file>
                </md-input-container>
            </form>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-primary" @click="closeDialog('upload')">Cancel</md-button>
            <md-button class="md-primary" @click="upload()">Upload</md-button>
        </md-dialog-actions>
    </md-dialog>
</div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

const ProfilePhoto = {
    name: 'profile-photo',
    data: function() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    methods: {
        onFileUpload(evt) {
            this.file = evt[0];
        },
        updateProfilePhoto(data) {
            const storageRef = firebase.storage().ref();
            storageRef.child('profile/' + this.user.uid + '.png').putString(data, 'data_url').then((snapshot) => {
                // Upload completed successfully, now we can get the download URL
                const downloadURL = snapshot.downloadURL;
                firebase.auth().currentUser.updateProfile({ photoURL: downloadURL }).then(() => {
                    this.closeDialog('upload');
                });

                this.$store.dispatch('updateUser', {
                    uid: this.user.uid, 
                    update: {
                        profile_picture: downloadURL
                    }
                });
            });
        },
        upload() {
            console.log(this.file);
            const fileReader = new FileReader();
            fileReader.readAsDataURL(this.file);

            fileReader.onload = () => {
                this.updateProfilePhoto(fileReader.result);
            };
        },
        open() {
            this.$refs.upload.open();
        },
        closeDialog(ref) {
            this.$refs[ref].close();
        }
    }
};
export default ProfilePhoto;
</script>

<style>
</style>


// WEBPACK FOOTER //
// profile-photo.vue?60f38717